import axios, { Method } from '@/apps/open/utils/axios'

const serverPath = '/api/service/wwo'

/**
 * 申请文档转换服务应用
 */
export const applyDocConversionApp = (data: object, params: object) => axios({ url: `${serverPath}/trans/apps`, method: Method.Post, data, params })

/**
 * 更新转换服务应用
 */
export const updateDocConversionApp = (params: object, appid: string, urlParams: object) => axios({ url: `${serverPath}/trans/apps/${appid}`, method: Method.Put, data: params, params: urlParams })

/**
 * 获取开发者的文档转换服务应用列表
 */
export const getDocConversionApps = (params: object) => axios({ url: `${serverPath}/trans/developer/apps`, method: Method.Get, params })

/**
 * 根据应用id获取应用信息
 */
export const getConversionAppInfoById = (app_id: string, params: object) => axios({ url: `${serverPath}/trans/apps/${app_id}`, method: Method.Get, params })

/**
 * 重置应用的app key
 */
export const resetConversionAppKey = (app_id: string, params: object) => axios({ url: `${serverPath}/apps/${app_id}/appkey`, method: Method.Put, params })
